import classNames from 'classnames'
import { useField } from 'remix-validated-form'
import { twMerge } from 'tailwind-merge'
import { FormInputWrapperProps } from './FormInputWrapper'

type FormInputProps = {
  readOnly?: boolean
  labelClassName?: string
  checkboxClassName?: string
  errorClassName?: string
  defaultChecked?: boolean
} & FormInputWrapperProps<HTMLInputElement>

export default function FormCheckBox({
  label,
  name,
  readOnly,
  labelClassName,
  checkboxClassName,
  errorClassName,
  ...props
}: FormInputProps) {
  const { error, getInputProps } = useField(name, {
    validationBehavior: { initial: `onSubmit`, whenTouched: `onSubmit`, whenSubmitted: `onSubmit` },
  })

  return label ? (
    <>
      <label
        htmlFor={name}
        className={classNames(
          `inline-flex items-center text-body-sm text-neutral-700`,
          labelClassName,
          props.disabled && `text-trn-300`,
        )}
      >
        <input
          {...getInputProps({
            ...props,
            type: `checkbox`,
            readOnly,
          })}
          id={name}
          defaultChecked={props.defaultChecked}
          className={twMerge(
            `mr-1.5 h-4 w-4 rounded`,
            checkboxClassName,
            props.disabled && `border-gray-300 checked:text-gray-300`,
          )}
        />
        {label}
      </label>
      {error && <div className={twMerge(`mt-0.5 text-sm text-red-600`, errorClassName)}>{error}</div>}
    </>
  ) : (
    <>
      <input
        {...getInputProps({
          ...props,
          type: `checkbox`,
          readOnly,
        })}
        id={name}
        defaultChecked={props.defaultChecked}
        className={twMerge(
          `h-4 w-4 rounded`,
          checkboxClassName,
          props.disabled && `border-gray-300 checked:text-gray-300`,
        )}
      />
      {error && <div className={twMerge(`mt-0.5 text-sm text-red-600`, errorClassName)}>{error}</div>}
    </>
  )
}
